/* import __COLOCATED_TEMPLATE__ from './attributes-list.hbs'; */
/**

 ## Card Body

 The `sq-card/attributes-list` block component is designed to be used in a [sq-card](/components/glass/sq-card.html).

```example
@title Basic Example

{{#sq-card/attributes-list as |list|}}
  {{#list.attribute label="First Name"}}
    Henry
  {{/list.attribute}}
  {{#list.attribute label="Last Name"}}
    Freel
  {{/list.attribute}}
  {{#list.attribute label="Email"
                    isFullWidth=true}}
    egray@chrometastic.com
  {{/list.attribute}}
  {{#list.attribute label="Phone"
                    isFullWidth=true}}
    (401) 555-1234
  {{/list.attribute}}
{{/sq-card/attributes-list}}

 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'dl',
  classNames: ['card__attributes-list'],
  attributeBindings: ['data-test-card-attributes-list'],
  'data-test-card-attributes-list': true
});